import { AppState, useAppSelector } from '@redux/store';
import { Participant, ParticipantRole } from '@typings/participant';

export const useCurrentUserParticipantData = (showId: string) =>
  useAppSelector(
    ({ auth, participants }: AppState): Participant | undefined => {
      if (!auth.user) {
        return undefined;
      }
      const id = auth.user.id;
      return Object.values(participants.byId).find(
        (participant) =>
          participant.profileId === id && participant.showId === showId,
      );
    },
  );

export const useHostData = (showId: string) =>
  useAppSelector(({ participants }: AppState): Participant | undefined => {
    return Object.values(participants.byId).find(
      (participant) =>
        participant.role === ParticipantRole.Host &&
        participant.showId === showId,
    );
  });

export const useCoHostData = (showId: string) =>
  useAppSelector(({ participants }: AppState): Participant | undefined => {
    return Object.values(participants.byId).find(
      (participant) =>
        participant.role === ParticipantRole.CoHost &&
        participant.showId === showId,
    );
  });

export const useParticipantDataById = (id?: string | null) =>
  useAppSelector(({ participants }: AppState): Participant | null =>
    id ? participants.byId[id] : null,
  );
